// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2YAKx","inputWrap":"Table_inputWrap__3i2pJ","col":"Table_col__2jR8b","bmiTooltip":"Table_bmiTooltip__16XhC"};